// extracted by mini-css-extract-plugin
export const main = "bottom-nav-module--main--1AZLK";
export const links = "bottom-nav-module--links--2kMdb";
export const action = "bottom-nav-module--action--1nImI";
export const extraSmall = "bottom-nav-module--extraSmall--3ZpuI";